import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import RestartTable from "./AccordionData/RestartTable"

const MyAccordion = (props) => {
  const {stats_data,
    t_get_stats_restarting_all_devs_by_5days
  } = props
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div id="accordion">
      {/* Header for the first section */}
      <div className="card" style={{ margin: "0" }}>
        <div className="card-header border border-secondary" id="heading1">
          <h5 className="mb-0">
            <button
              className="btn"
              onClick={() => {
                toggleAccordion(0)
                t_get_stats_restarting_all_devs_by_5days()
              }}
              aria-expanded={openIndex === 0}
              aria-controls="collapse1"
            >
              Devices Restart
            </button>
          </h5>
        </div>

        <div
          id="collapse1"
          className={`collapse ${openIndex === 0 ? 'show' : ''}`}
          aria-labelledby="heading1"
          data-parent="#accordion"
        >
          <div className="card-body">
          <RestartTable 
                stats_data = {stats_data}
                //t_get_stats_restarting_all_devs_by_5days = {t_get_stats_restarting_all_devs_by_5days}
              />
          </div>
        </div>
      </div>

      {/* Header for the second section */}
      <div className="card" style={{ margin: "0" }}>
        <div className="card-header border border-secondary" id="heading2">
          <h5 className="mb-0">
            <button
              className="btn "
              onClick={() => toggleAccordion(1)}
              aria-expanded={openIndex === 1}
              aria-controls="collapse2"
            >
              -----2-----
            </button>
          </h5>
        </div>

        <div
          id="collapse2"
          className={`collapse ${openIndex === 1 ? 'show' : ''}`}
          aria-labelledby="heading2"
          data-parent="#accordion"
        >
          <div className="card-body">
            -----No Contenet yet-----
          </div>
        </div>
      </div>


    </div>
  );
};

export default MyAccordion;